import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { ColumnOption } from "../../../constants/schema.js";
import { addColumnAction, changeColumnPrimaryKeyAction, removeColumnAction } from "./atom.actions.js";
import { bHas } from "../../../utils/bit.js";
import { validateForeignKeys } from "./keys.js";
import { addRelationshipAction, changeRelationshipColumnsAction, removeRelationshipAction } from "../relationship/atom.actions.js";
import { addTableAction, removeTableAction } from "../table/atom.actions.js";
import { asapScheduler, observeOn, throttle, timer } from "rxjs";
//#region src/engine/modules/table-column/hooks.ts
var deferred = (action$) => action$.pipe(observeOn(asapScheduler));
var changeColumnNotNullHook = (action$, getState) => deferred(action$).subscribe(({ payload: { id } }) => {
	const { collections } = getState();
	const column = query(collections).collection("tableColumnEntities").selectById(id);
	if (!column) return;
	if (!bHas(column.options, ColumnOption.primaryKey)) return;
	if (bHas(column.options, ColumnOption.notNull)) return;
	column.options = column.options | ColumnOption.notNull;
});
var validationForeignKeyHook = (action$, getState) => action$.pipe(throttle(() => timer(0, asapScheduler), {
	leading: false,
	trailing: true
})).subscribe(() => validateForeignKeys(getState()));
var hooks = [[[changeColumnPrimaryKeyAction], changeColumnNotNullHook], [[
	addRelationshipAction,
	removeRelationshipAction,
	changeRelationshipColumnsAction,
	addColumnAction,
	removeColumnAction,
	addTableAction,
	removeTableAction
], validationForeignKeyHook]];
//#endregion
export { hooks };
